// Prevent pages from being loaded directly by URL or reload,
// which would cause the page to be rendered without a valid state.
export default defineNuxtRouteMiddleware((to, from) => {
    return  // TODO: Remove this line to enable the middleware
    if (to.path !== '/' && to.path === from.path) {
        return navigateTo('/')
    }
})
